import { gql } from '@apollo/client';

export const qualityReturnReasonsListQuery = gql`
  query {
    qualityReturnReasonsList {
      reasonId
      reasonDescription
      reasonGroupId
    }
  }
`;
